module.exports = __webpack_public_path__ + "static/media/icong.9a05a556.svg";